import { useState } from "react";
import { Link } from "react-router-dom";
import { useT } from "../i18n";

export default function ForgotPasswordPage() {
  const t = useT();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res = await fetch("/api/auth/forgot-password", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      if (!res.ok && res.status !== 204) throw new Error("Error al procesar la solicitud");
      setSent(true);
    } catch {
      setError(t("auth.forgotError"));
    } finally {
      setLoading(false);
    }
  };

  const G = "#0891b2";

  return (
    <>
      <style>{`
        @keyframes fadeSlideUp { from { opacity:0;transform:translateY(20px); } to { opacity:1;transform:translateY(0); } }
        @keyframes spin { to { transform: rotate(360deg); } }
        .fp-input {
          width:100%;padding:12px 16px;background:rgba(255,255,255,.65);
          border:1px solid rgba(255,255,255,.85);border-radius:12px;color:#0c1f26;
          font-size:.92rem;outline:none;transition:border-color .2s,box-shadow .2s;
          backdrop-filter:blur(8px);box-sizing:border-box;
        }
        .fp-input:focus { border-color:rgba(8,145,178,.7);box-shadow:0 0 0 3px rgba(8,145,178,.12); }
        .fp-btn {
          width:100%;padding:13px;border:none;border-radius:12px;font-size:.97rem;
          font-weight:700;cursor:pointer;transition:transform .15s,box-shadow .2s;
          background:linear-gradient(135deg,#06b6d4,#0891b2,#0e7490);color:#fff;
          box-shadow:0 4px 20px rgba(8,145,178,.40);
        }
        .fp-btn:hover:not(:disabled) { transform:translateY(-1px); }
        .fp-btn:disabled { opacity:.6;cursor:not-allowed; }
      `}</style>

      <div style={{ minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",background:"linear-gradient(145deg,#cce8f0,#daf1f7,#c8e8f5)",position:"relative",overflow:"hidden" }}>
        <div style={{ position:"relative",width:"100%",maxWidth:420,margin:"1.5rem",animation:"fadeSlideUp .5s cubic-bezier(.22,1,.36,1) both" }}>
          <div style={{ position:"absolute",inset:-1,borderRadius:26,background:"linear-gradient(135deg,rgba(255,255,255,.9),rgba(8,145,178,.2),rgba(255,255,255,.7))",zIndex:0,filter:"blur(.5px)" }} />
          <div style={{ position:"relative",zIndex:1,background:"rgba(255,255,255,.60)",backdropFilter:"blur(28px) saturate(180%)",borderRadius:24,border:"1px solid rgba(255,255,255,.85)",boxShadow:"0 24px 64px rgba(8,145,178,.13)",padding:"2.5rem 2.25rem" }}>

            <div style={{ display:"flex",justifyContent:"center",marginBottom:"1.5rem" }}>
              <img src="/helixscan-logo.png" alt="HelixScan" style={{ height:36,objectFit:"contain" }} />
            </div>

            {sent ? (
              <div style={{ textAlign:"center" }}>
                <div style={{ fontSize:"2.5rem",marginBottom:"1rem" }}>📧</div>
                <h2 style={{ margin:"0 0 12px",fontSize:"1.1rem",fontWeight:700,color:"#0c1f26" }}>{t("auth.checkEmail")}</h2>
                <p style={{ margin:"0 0 1.5rem",fontSize:"0.88rem",color:"rgba(12,31,38,.55)",lineHeight:1.6 }}>
                  {t("auth.sentTextPre")} <strong>{email}</strong> {t("auth.sentTextPost")}
                </p>
                <p style={{ margin:"0 0 1.5rem",fontSize:"0.78rem",color:"rgba(12,31,38,.4)" }}>
                  {t("auth.linkExpires")}
                </p>
                <Link to="/login" style={{ color:G,fontWeight:600,fontSize:"0.88rem",textDecoration:"none" }}>{t("auth.backToLogin")}</Link>
              </div>
            ) : (
              <>
                <h2 style={{ margin:"0 0 8px",fontSize:"1.1rem",fontWeight:700,color:"#0c1f26",textAlign:"center" }}>{t("auth.resetTitle")}</h2>
                <p style={{ margin:"0 0 1.75rem",fontSize:"0.83rem",color:"rgba(12,31,38,.5)",textAlign:"center",lineHeight:1.5 }}>
                  {t("auth.forgotDesc")}
                </p>

                {error && (
                  <div style={{ background:"rgba(220,38,38,.08)",border:"1px solid rgba(220,38,38,.25)",borderRadius:10,padding:"10px 14px",color:"#dc2626",fontSize:"0.84rem",marginBottom:"1rem" }}>
                    {error}
                  </div>
                )}

                <form onSubmit={handleSubmit}>
                  <div style={{ marginBottom:"1.25rem" }}>
                    <label style={{ display:"block",fontSize:"0.72rem",fontWeight:700,letterSpacing:"0.7px",textTransform:"uppercase",color:"rgba(12,31,38,.5)",marginBottom:6 }}>{t("auth.email")}</label>
                    <input
                      className="fp-input"
                      type="email"
                      value={email}
                      onChange={e => setEmail(e.target.value)}
                      placeholder={t("auth.forgotEmailPlaceholder")}
                      required
                      autoFocus
                    />
                  </div>
                  <button type="submit" className="fp-btn" disabled={loading}>
                    {loading ? (
                      <span style={{ display:"flex",alignItems:"center",justifyContent:"center",gap:10 }}>
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" style={{ animation:"spin .8s linear infinite" }}>
                          <path d="M12 2a10 10 0 0 1 10 10" strokeLinecap="round"/>
                        </svg>
                        {t("auth.sending")}
                      </span>
                    ) : t("auth.sendLink")}
                  </button>
                </form>

                <div style={{ marginTop:"1.5rem",textAlign:"center" }}>
                  <Link to="/login" style={{ color:"rgba(12,31,38,.4)",fontSize:"0.82rem",textDecoration:"none" }}>{t("auth.backToLogin")}</Link>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
